<template>
  <div class="wrapper">
      <main-navbar></main-navbar>
      <!-- <parallax class="section page-header header-filter" :style="headerStyle"> -->
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container" >
        <div class="md-layout">
          <div
            class="md-layout-item md-size-70 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">Penyimpanan Data Yang Terintegrasi</h1>
            <h4>
              Setiap data perlu penyimpanan yang bagus, terintegrasi, dan terjamin keamananya.
              untuk itu kami hadir dengan menawarkan aplikasi penyimpanan data
              yang akan memenuhi semua kebutuhan anda.a
            </h4>
            <br />
            <md-button
              href="https://www.youtube.com/watch?v=DZsklX1RwhI"
              class="md-white md-lg md-round"
              target="_blank"
              style="font-size:100px;"
              >Tonton Demo</md-button
            >
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section" >
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-90 md-xsmall-size-100 mx-auto text-center"
            >
              <h1 class="title text-center">Produk Kami</h1>
              <h4 class="description" style="margin-top:50px;">
                The Arctic Ocean freezes every winter and much of the sea-ice then thaws every summer,
            and that process will continue whatever happens with climate change. Even if the Arctic continues to be one of the fastest-warming regions of the world,
            it will always be plunged into bitterly cold polar dark every winter. And year-by-year, for all kinds of natural reasons,
            there’s huge variety of the state of the ice.
                <!-- Kami membuat sistem dimana semua pekerjaan workhsop dilakukan
                didalam satu sistem. terintegrasi, mudah dilakukan dimana saja,
                dengan sistem penyimpanan gudang part dan material. dan dilengkapi
                dengan invoice yang membuat semua alur pekerjaan menjadi mudah dan lebih
                efisien  -->
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="section" >
        <div class="container">
          <h1 class="title text-center" >Mengapa Memilih Produk Kami ?</h1>
          <div class="md-layout" style="margin-top:100px;">
              <div class="md-layout-item md-mengapa md-size-25 md-medium-size-25 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/Reliable.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan1">
                      Reliable
                      </h4>
                      </div>
                </div>
              </div>

              <div class="md-layout-item md-mengapa md-size-25 md-medium-size-25 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/Adjustable.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan1">
                      Adjustable
                    </h4>
                      </div>
                </div>
              </div>

              <div class="md-layout-item md-mengapa md-size-25 md-medium-size-25 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/Everywhere.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan1">
                      Can be accesed from everywhere
                    </h4>
                      </div>
                </div>
              </div>

              <div class="md-layout-item md-mengapa md-size-25 md-medium-size-25 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/Inventory.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan1">
                      integration with inventory system
                    </h4>
                      </div>
                </div>
              </div>
          </div>

          <div class="md-layout" style="margin-top:30px;">
              <div class="md-layout-item md-mengapa1 md-size-33 md-medium-size-33 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/user.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan">
                      User friendly
                    </h4>
                      </div>
                </div>
              </div>
              <div class="md-layout-item md-mengapa1 md-size-33 md-medium-size-33 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/API.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan">
                      Open API
                    </h4>
                      </div>
                </div>
              </div>
              <div class="md-layout-item md-mengapa1 md-size-33 md-medium-size-33 md-small-size-50">
                <div class="team-player">
                      <img
                        src="@/assets/images/247.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-kelebihan rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="kelebihan">
                      24/7 Support
                    </h4>
                      </div>
                </div>
              </div>
          </div>
            </div>
      </div>


      <!-- <div class="section">      <div class="container">
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>assignment</md-icon>
                  </div>
                  <h4 class="info-title">Fitur 1</h4>
                  <p>
                    deskripsi fitur deskripsi fitur deskripsi fitur
                    deskripsi fitur deskripsi fitur deskripsi fitur 
                    deskripsi fitur deskripsi fitur deskripsi fitur 
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>assignment</md-icon>
                  </div>
                  <h4 class="info-title">Fitur 2</h4>
                  <p>
                    deskripsi fitur deskripsi fitur deskripsi fitur
                    deskripsi fitur deskripsi fitur deskripsi fitur 
                    deskripsi fitur deskripsi fitur deskripsi fitur 
                  </p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>assignment</md-icon>
                  </div>
                  <h4 class="info-title">Fitur 3</h4>
                  <p>
                    deskripsi fitur deskripsi fitur deskripsi fitur
                    deskripsi fitur deskripsi fitur deskripsi fitur 
                    deskripsi fitur deskripsi fitur deskripsi fitur. 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="section-story-overview">
        <div class="row">
          <div class="col-md-6">
            <div class="image-container image-left" :style="headerStyle">
              <p class="blockquote blockquote-primary">
                "Over the span of the satellite record, Arctic sea ice has been declining significantly,
                while sea ice in the Antarctichas increased very slightly" 
                <br>
                <br>
                <small>-NOAA</small>
              </p>
            </div>
          <div class="image-container" style="background-image: "></div>
        </div>
        <div class="col-md-5">
          <div class="image-container image-right" style="background-image: url(&quot;img/bg1.jpg&quot;);"></div>
          <h3> So what does the new record for the lowest level of winter ice actually mean </h3>
          <p> 
            The Arctic Ocean freezes every winter and much of the sea-ice then thaws every summer,
            and that process will continue whatever happens with climate change. Even if the Arctic continues to be one of the fastest-warming regions of the world,
            it will always be plunged into bitterly cold polar dark every winter. And year-by-year, for all kinds of natural reasons,
            there’s huge variety of the state of the ice.
          </p>
          <p>
            For a start, it does not automatically follow that a record amount of ice will melt this summer.
            More important for determining the size of the annual thaw is the state of the weather as the midnight sun approaches and temperatures rise.
            But over the more than 30 years of satellite records, scientists have observed a clear pattern of decline, decade-by-decade.
          </p>
          <p>
            The Arctic Ocean freezes every winter and much of the sea-ice then thaws every summer, and that process will continue whatever happens with climate change.
            Even if the Arctic continues to be one of the fastest-warming regions of the world, it will always be plunged into bitterly cold polar dark every winter.
            And year-by-year, for all kinds of natural reasons, there’s huge variety of the state of the ice.
          </p>
        </div>
      </div>
    </div> -->

      <div class="section section-how-to text-center" :style="bgck">
        <div class="container" >
          <h1 style="color:white; margin-top:150px;" class="title text-center">Bagaimana Cara Kerja Workshop System ?</h1>
            <div class="md-layout" style="margin-top:100px;" >
              <div class="md-layout-item md-medium-size-33 md-mengapa md-size-33 md-small-size-50">
                <div class="team-player">
                  
                    
                      <img
                        src="@/assets/images/Data_customer.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-cara rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="card-title">
                      Input customer and vehicle data
                    </h4>
                      </div>
                    </div>
                  
                </div>

              <div class="md-layout-item md-medium-size-33 md-mengapa md-size-33 md-small-size-50">
                <div class="team-player">
                  
                    
                      <img
                        src="@/assets/images/Estimate.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-cara rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="card-title">
                      Create service estimates
                      for customers
                    </h4>
                      </div>
                    </div>
                  
                </div>

              <div class="md-layout-item md-medium-size-33 md-mengapa md-size-33 md-small-size-50">
                <div class="team-player">
                  
                    
                      <img
                        src="@/assets/images/PKB.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-cara rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="card-title">
                      Create PKB (Perintah kerja bengkel) for technicians
                    </h4>
                      </div>
                    </div>
                  
                </div>
            </div>

            <div class="md-layout" style="margin-top:50px;">
              <div class="md-layout-item md-medium-size-33 md-mengapa md-size-33 md-small-size-50">
                <div class="team-player">
                  
                    
                      <img
                        src="@/assets/images/Sparepart.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-cara rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="card-title">
                        Create a spare part/material note
                    </h4>
                      </div>
                    </div>
                  
                </div>

              <div class="md-layout-item md-medium-size-33 md-mengapa md-size-33 md-small-size-50">
                <div class="team-player">
                  
                    
                      <img
                        src="@/assets/images/Note.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-cara rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="card-title">
                        Create a workshop service note
                      </h4>
                      </div>
                    </div>
                  
                </div>

              <div class="md-layout-item md-medium-size-33 md-mengapa md-size-33 md-small-size-50">
                <div class="team-player">
                  
                    
                      <img
                        src="@/assets/images/Invoice.png"
                        alt="Thumbnail Image"
                        class="img-raised icon-cara rounded-circle img-fluid"
                      />
                      <div class="title-icon">
                      <h4 class="card-title">
                      Create Invoice
                    </h4>
                      </div>
                    </div>
                  
                </div>
              
            </div>
        </div>
      </div>

      <div class="section text-center">
        <div class="container" style="padding-top:100px;" >
          <h2 class="title">Fitur Apa Saja Yang Ada Pada Workshop System ?</h2>
          <div class="team">
            <div class="md-layout">
              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>

              <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card>
                    <div class="judul-fitur">
                    <img src="@/assets/images/Ellipse.png"
                      class="ellipse" />
                    <h4 class="fitur-title">
                      
                      Service Estimate
                      <br />
                    </h4>
                    </div>
                    <md-card-content>
                      <p class="fitur-description md-fitur-desc-size">
                        <!-- You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site. -->
                        asdasd asddddddd ddddddddddd ddddddddddddd ddddddddddd
                        asdasdasdasd dddddd dddddddddddddddddd dddddddd dddddd
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                        asdasdasd asdasdhag sjdhgajsda jshdgjas hgdjahgsd jash
                      </p>
                      <!-- <h4>Rp <span style="font-size: 30px;">50.000.000</span>/tahun</h4> -->
                    </md-card-content>
                    <md-card-actions class="text-center">
                      
                    </md-card-actions>
                  </md-card>
                </div>
              </div>
              

              
              <!-- <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img
                        :src="teamImg3"
                        alt="Thumbnail Image"
                        class="img-raised rounded-circle img-fluid"
                      />
                    </div>
                    <h4 class="card-title">
                      Input Data Service Estimate
                      <br />
                      <small class="card-description text-muted">Model</small>
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        You can write here details about one of your team
                        members. You can give more details about what they do.
                        Feel free to add some <a href="#">links</a> for people
                        to be able to follow them outside the site.
                      </p>
                    </md-card-content>

                    <md-card-actions class="text-center">
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-twitter"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-instagram"></i>
                      </md-button>
                      <md-button
                        href="javascript:void(0)"
                        class="md-just-icon md-simple"
                      >
                        <i class="fab fa-facebook-square"></i>
                      </md-button>
                    </md-card-actions>
                  </md-card>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="section text-center">
        <div class="container" >
          <div class="team">
            <div class="md-layout ">
              <div class="md-layout-item md-size-50  md-medium-size-50 md-small-size-100">
                <img src="@/assets/images/Image_tertarik.png" style="height:750px; width:450px;" />
              </div>
              <div class="md-layout-item md-size-50-tertarik md-medium-size-50 md-small-size-100-tertarik" style="margin-top:200px;">
                <h1 class="title" style="text-align:left; margin-left:60px;">Tertarik ?</h1>
                <h4 class="fitur-title" style=" margin-left:60px; margin-top:60px;  margin-right:20px;">Andaa bisa memilih paket apa saja yang ada atau bisa melakukan custom paket</h4>
                <div style="width:100%; text-align:left; margin-left:60px;">
                <md-button class=" md-lg md-round md-primary" style="font-size:100px;  margin-top:40px;" >Pilih Paket</md-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </div>
      

      <div class="section section-contacts">
        <div class="container" >
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Bekerja dengan kami</h2>
              <h4 class="text-center description">
                Bagilah detail tentang produk atau pekerjaan agensi Anda menjadi beberapa bagian. 
                Tulis beberapa baris tentang masing-masing dan hubungi kami tentang kolaborasi lebih lanjut. 
                Kami akan merespon kembali kepada Anda secepatnya.
              </h4>
              <form class="contact-form">
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Your Name</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <md-field>
                      <label>Your Email</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Your Message</label>
                  <md-textarea v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button class="md-success">Send Message</md-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer/>
  </div>
</template>

<script>
import parralax from "@/components/Parallax";
import MainNavbar from "@/pages/Dashboard/Layout/MainNavbar.vue";
import ContentFooter from "../Dashboard/Layout/ContentFooter.vue";
export default {
    components: {
        "parallax": parralax,
        "main-navbar":MainNavbar,
        "content-footer":ContentFooter
  },
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/images/erp.png")
    },
    carakerja: {
      type: String,
      default: require("@/assets/images/Background.png")
    },
    // teamImg1: {
    //   type: String,
    //   default: require("@/assets/img/faces/avatar.jpg")
    // },
    // teamImg2: {
    //   type: String,
    //   default: require("@/assets/img/faces/christian.jpg")
    // },
    teamImg3: {
      type: String,
      default: require("@/assets/images/avatar.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    bgck() {
      return {
        backgroundImage: `url(${this.carakerja})`
      };
    }

  }
};
</script>

<style lang="scss" scoped>
// body{
//     margin:0;
// }
// .wrapper{
//     height: 100vh;
//     overflow-x: hidden;
//     overflow-y: auto;
//     perspective: 100px;
// }

 .md-toolbar-row, .section .container, .footer .container {
    max-width: 1210px;
}


.section-how-to{
  -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: 100%;
    
}


// .main-raised {
//     // margin: -60px 30px 0px;
//     border-radius: 6px;
//     -webkit-box-shadow: 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
//     box-shadow: 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
// }



.container, .container-fluid {
    // display: -webkit-box;
    // display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    // max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}

.container, .section .container, .section .container-fluid {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.md-layout {
  width:100%;
  padding: auto;
    margin-right: -15px;
}

.md-layout-item.md-size-66 {
    min-width: 66.6666%;
    max-width: 66.6666%;
    flex: 0 1 66.6666%;
}
.md-layout-item {
    padding-right: 15px;
    padding-left: 15px;
    
}
.mr-auto, .mx-auto {
    margin-right: auto !important;
}
.ml-auto, .mx-auto {
    margin-left: auto !important;
}

// .title.text-center {
//   text-align: center;
//   font-size:50px;
// }

.container .h4, .description{
  // font-weight: bold;
  text-align: justify;
  text-align-last: center;
  font-style: roboto;
  color:black;
}

.fitur-description{
  padding-left:50px;
  padding-right:20px;
  text-align: justify;
}

@media (max-width:960px){
// .md-fitur-desc-size{min-width:380px;max-width:380px;flex:0 1 180px}
.md-small-size-100-tertarik{
  min-width:100%;max-width:100%;margin-left:0!important;flex:1 1 100%;
  margin-top:0px !important;
}

}

.text-center {
    text-align: center;
}

.md-layout-item {
    width: 100%;
    flex: 1 1;
}

.main {
    background: #FFFFFF;
    position: relative;
    z-index: 3;
}

html {
  height: 100%;
  box-sizing: border-box;
}

body {
  min-height: 100%;
  margin: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: Roboto, 'Noto Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}
// .parralax{
//     position: relative;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     height: 100%;
//     transform-style: preserve-3d;
//     z-index: -1 ;
// }



.page-header .title, .card-title {
    color: #FFFFFF;
}




.title, .info-title, .footer-brand, .footer-big h5, .footer-big h4, .media .media-heading {
    font-weight: 700;
    font-family: Roboto;
}



.section .md-layout .title {
    margin-top: 30px;
    margin-bottom: 25px;
    min-height: 32px;
}
.title, .title a, .info-title, .info-title a, .footer-brand, .footer-brand a, .footer-big h5, .footer-big h5 a, .footer-big h4, .footer-big h4 a, .media .media-heading, .media .media-heading a {
    color: rgb(17, 17, 145);
    text-decoration: none;
}



h1{
    font-size: 3.3125rem;
    line-height: 1.15em;
}
h2, .h2 {
    font-size: 2.25rem;
    line-height: 1.5em;
}


h4{
    font-size: 1.125rem;
    line-height: 1.4em;
    font-weight: 300;
}

.kelebihan,  .card-title{
  margin-top:20px;
  text-align: center;
  font-weight:bold;
  font-size:22px;
}

.kelebihan1{
  margin-top:20px;
  height:80px;
  text-align: center;
  font-weight:bold;
  font-size:22px;
}


// h4, .h4 {
//     font-size: 1.125rem;
//     line-height: 1.5em;
// }



h5 {
    display: block;
    
    margin-block-start: 1.67em;
    margin-block-end: 1.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    // font-weight: bold;
}

h5, .h5 {
    font-size: 1.0625rem;
    line-height: 1.4em;
    margin-bottom: 15px;
}

.md-card{
  box-shadow: 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(0 0 0 / 20%);
  border-radius: 25px !important;
  height:370px;
  // width:320px ;
}

.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.info {
    max-width: 360px;
    margin: 0 auto;
    padding: 70px 0 30px;
}


.info .icon {
    color: #999999;
}
.icon.icon-info i {
    color: #00bcd4 !important;
}

.icon.icon-success i {
    color: #4caf50 !important;
}

.icon.icon-danger i {
    color: #f44336 !important;
}
.info .icon > i {
    font-size: 3.85rem !important;
    min-width: auto;
    width: auto;
    height: auto;
    vertical-align: unset;
}


.md-content {
  background-color: transparent;
    width: 200px;
    height: 200px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

.md-white{
  background-color: #ffffff !important;
  color:blue !important;
  font-size:150px !important;
}

.md-layout-item.md-mengapa{
  padding-top:30px;
  margin:auto;

}

.md-layout-item.md-mengapa1{
  // float: left;
  padding-top:30px;
  margin:auto;
}

.icon-kelebihan{
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 200px;
  width: 200px;
}

.icon-cara{
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 200px;
  width: 200px;
}

// img {
//     max-width: 100%;
//     height: auto;
// }



.title-icon{
  text-align: center;
  width:80%;
  margin: auto;
}

.judul-fitur{
  width: 100%;
  margin-top:20px;
}

.fitur-title{
  font-weight: bold;
  text-align: left;
  font-size:22px;
}

.ellipse{
  width:30px;
  float:left;
  margin-left: 20px;
  margin-right: 20px;
}

// .team-player .md-card{
//   width:300px ;
//   height: 400px;
// }

// .image_tertarik{
//   display: block;
//   margin-left: auto;
//   margin-right: auto;
//   height: 800px;
//   width: 500px;
// }

// .layout-tertarik{
//   max-width:90%;
// }


// .img-raised {
//     -webkit-box-shadow: 0 10px 25px 0 rgb(0 0 0 / 30%);
//     box-shadow: 0 10px 25px 0 rgb(0 0 0 / 30%);
// }
// .rounded-circle {
//     border-radius: 50%!important;
// }
// .img-fluid, .img-thumbnail {
//     max-width: 100%;
//     height: auto;
// }

// img{
//   max-width:100px;
//   color:black;
//   border: 1px solid black;
// }
// p {
//     font-size: 14px;
//     margin: 0 0 10px;
    
// }
// p {
//     display: block;
//     margin-block-start: 1em;
//     margin-block-end: 1em;
//     margin-inline-start: 0px;
//     margin-inline-end: 0px;
// }
// body {
//     background-color: #EEEEEE;
//     letter-spacing: unset;
//     font-size: 1rem;
//     color: #3C4858;
//     line-height: 1.5em;
// }
</style>
